const documentTypes = [
  'NATIONAL_ID_CARD',
  'PASSPORT'
]
export { documentTypes }
